import { getOrderReducer } from '@features/orderForm/common/services/redux/commonOrderFormSelectors';
import { RootState } from '@config/hooks';

export const getOneOffSideOrdersSlice = (state: RootState) =>
  getOrderReducer(state).oneOffSideOrders;
export const getOneOffsSelectedFees = (state: RootState) =>
  getOneOffSideOrdersSlice(state).selectedFees;
